import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FormGroup, FormControl, Validators} from '@angular/forms';
import { ReportService } from "src/app/_services/report.service";
import { ErrorUtil } from "src/app/_utilities/error";
import { NgxSpinnerService } from 'ngx-spinner';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { UsersService } from "src/app/_services/admin/users.service";
import { AuthenticationService } from "src/app/auth/authentication.service";

@Component({
  selector: "app-report-export",
  templateUrl: "./report-export.component.html",
  styleUrls: ["./report-export.component.scss"],
  standalone: false,
})
export class ReportExportComponent implements OnInit {
  exportForm: FormGroup;
  data: any;
  currentFolder: any = {
    name: "",
    id: "",
  };
  selectedReportName: string = "";
  reportDetails: any;
  translate: any;
  users: any = [];
  user_groups: any = [];

  constructor(
    public modalRef: BsModalRef,
    private reportService: ReportService,
    private errorUtil: ErrorUtil,
    private spinner: NgxSpinnerService,
    private languageTranslateService: LanguageTranslateService,
    private userService: UsersService,
    private auth: AuthenticationService,
  ) {
    this.exportForm = new FormGroup({
      fileType: new FormControl("", [Validators.required]),
      sendEmail: new FormControl(false),
      recipientsUser: new FormControl([]),
      recipientsGroup: new FormControl([]),
      otherRecipients: new FormControl([], [Validators.email]),
    });
  }

  ngOnInit(): void {
    this.currentFolder.name = this.data?.folderName;
    this.currentFolder.id = this.data?.folderId;
    this.selectedReportName = this.data?.name;
    this.reportDetails = this.data?.reportDetails;
    this.languageTranslateService.wordSrc$.subscribe((transData) => {
      if (Object.keys(transData).length != 0) {
        this.translate = transData;
      }
    });
  }

  onExportClick() {
    let exportType: string = this.exportForm.get("fileType")?.value;

    let fieldList: any = [];
    this.data?.fieldList?.map((field: any) => {
      let fieldAlias: string = this.formatFieldName(field.fieldName);
      fieldList.push({ fieldName: field.fieldName, alias: fieldAlias });
    });

    if (this.data.isAggregateReport) {
      fieldList = [];
    }

    let params: any = {
      id: this.data.id,
      reportName: this.selectedReportName,
      description:
        this.data.from == "viewer" || this.data.from == "list"
          ? this.reportDetails?.description
          : "",
      datasetName:
        this.data.from == "viewer" || this.data.from == "list"
          ? this.reportDetails.datasetName
          : this.data.dataset,
      fieldList:
        this.data.from == "viewer" || this.data.from == "list"
          ? this.reportDetails.fieldList
          : fieldList,
      fieldSortCriteria:
        this.data.from == "viewer" || this.data.from == "list"
          ? this.reportDetails.fieldSortCriteria
          : this.data.fieldSortCriteria,
      fieldFilterCriteria:
        this.data.from == "viewer" || this.data.from == "list"
          ? this.reportDetails.fieldFilterCriteria
          : this.data.fieldFilterCriteria,
      groupByFieldList:
        this.data.from == "viewer" || this.data.from == "list"
          ? this.reportDetails.groupByFieldList
          : this.data.groupByFieldList,
      fieldGroupByCriteria:
        this.data.from == "viewer" || this.data.from == "list"
          ? this.reportDetails.fieldGroupByCriteria
          : this.data.fieldGroupByCriteria,
      isAggregateReport:
        this.data.from == "viewer" || this.data.from == "list"
          ? this.reportDetails.isAggregateReport
          : this.data.isAggregateReport,
      folder: {
        id: this.currentFolder.id,
      },
    };

    //payload for send email
    let userFormValue: any = this.exportForm.get("recipientsUser")?.value;
    let users: any = userFormValue.map((item: any) => {
      return { id: item };
    });

    let groupFormValue: any = this.exportForm.get("recipientsGroup")?.value;
    let groups: any = groupFormValue.map((item: any) => {
      return { id: item };
    });

    if (this.exportForm.get("sendEmail")?.value === true) {
      //call send email api
      let emailAPIPayload: any = {
        report: params,
        fileType: exportType.toUpperCase(),
        externalEmails: this.exportForm.get("otherRecipients")?.value,
        users: users,
        userGroups: groups,
      };

      this.reportService.sendReportViaEmail(emailAPIPayload).subscribe(
        (res: any) => {
          if (res.status == 200) {
            this.errorUtil.setErrorMessage(
              200,
              this.translate.report.label.singular +
                " " +
                this.translate?.report.validationFE.sentRecipientSuccessfully,
              null,
              "success",
              2000,
            );
          }
        },
        (err: any) => {
          this.errorUtil.setErrorMessage(
            err.status,
            err.error ? err.error.title : null,
            err.error ? err.error.title : null,
            "error",
            2000,
          );
        },
      );
    }

    this.spinner.show();
    this.reportService.exportReport(params, exportType).subscribe(
      (res: any) => {
        this.spinner.hide();
        if (res.status == 200) {
          this.errorUtil.setErrorMessage(
            200,
            this.translate.report.label.singular +
              " " +
              this.translate.report.validationFE.exportedSuccesfully,
            null,
            "success",
            2000,
          );
          const url = window.URL.createObjectURL(res.body);
          let fileExtension: string =
            exportType == "pdf"
              ? "pdf"
              : exportType == "excel"
                ? "xlsx"
                : "csv";
          const a = document.createElement("a");
          a.href = url;
          a.download = this.selectedReportName + "." + fileExtension;
          a.click();
          window.URL.revokeObjectURL(url);
          this.modalRef.hide();
        }
      },
      (err: any) => {
        this.spinner.hide();
        console.log(err, "error in report export api");
        this.errorUtil.setErrorMessage(
          err.status,
          err.error ? err.error.title : null,
          err.error ? err.error.title : null,
          "error",
          2000,
        );
      },
    );
  }

  formatFieldName(field: string): string {
    return field
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  onUsersChange() {
    let formValue: any = this.exportForm.get("recipientsUser")?.value;
    if (formValue.length > 3) {
      formValue.pop(); // remove last selected item
      this.errorUtil.setErrorMessage(
        "400",
        null,
        this.translate?.report.validationFE.maximumUserSelectionExceeded,
        "warn",
        2000,
      );
      return;
    } else {
      //check if user length is 0
      if (formValue.length == 0) {
        //set validator to group because either one is required.
        this.exportForm.controls["recipientsGroup"].setValidators([
          Validators.required,
        ]);
        this.exportForm.controls["otherRecipients"].setValidators([
          Validators.required, Validators.email
        ]);
        this.exportForm.controls["recipientsGroup"].updateValueAndValidity();
        this.exportForm.controls["otherRecipients"].updateValueAndValidity();

        this.exportForm.controls["recipientsGroup"].markAsTouched();
        this.exportForm.controls["otherRecipients"].markAsTouched();
      } else {
        //remove the validator
        this.exportForm.controls["recipientsGroup"].clearValidators();
        this.exportForm.controls["recipientsGroup"].updateValueAndValidity();
         this.exportForm.controls["otherRecipients"].clearValidators();
         this.exportForm.controls["otherRecipients"].updateValueAndValidity();
      }
    }
  }

  getUsersList() {
    this.userService.getActiveUsers().subscribe((data: any) => {
      this.users = data;
      //logged in user should not be in the user list of sharing option
      this.users = this.users.filter(
        (user: any) => user.id !== parseInt(this.auth.getUserId()),
      );
    });
  }

  getGroupList() {
    this.userService.getAlluserGroup().subscribe((data: any) => {
      this.user_groups = data;
    });
  }

  onGroupChange() {
    let formValue: any = this.exportForm.get("recipientsGroup")?.value;
    if (formValue.length > 3) {
      formValue.pop(); // remove last selected item
      this.errorUtil.setErrorMessage(
        "400",
        null,
        this.translate?.report.validationFE.maximumGroupSelectionExceeded,
        "warn",
        2000,
      );
      return;
    } else {
      //check if group length is 0
      if (formValue.length == 0) {
        //set validator to user because either one is required
        this.exportForm.controls["recipientsUser"].setValidators([
          Validators.required,
        ]);
        this.exportForm.controls["recipientsUser"].updateValueAndValidity();
        this.exportForm.controls["recipientsUser"].markAsTouched();

        this.exportForm.controls["otherRecipients"].setValidators([
          Validators.required, Validators.email
        ]);
        this.exportForm.controls["otherRecipients"].updateValueAndValidity();
        this.exportForm.controls["otherRecipients"].markAsTouched();

      } else {
        //remove the validator
        this.exportForm.controls["recipientsUser"].clearValidators();
        this.exportForm.controls["recipientsUser"].updateValueAndValidity();

        this.exportForm.controls["otherRecipients"].clearValidators();
        this.exportForm.controls["otherRecipients"].updateValueAndValidity();
      }
    }
  }

  onEmailAdd(event: any) {
    let emailList: any = this.exportForm.get("otherRecipients")?.value;
    if (emailList.length > 3) {
      emailList.pop();
      this.errorUtil.setErrorMessage(
        "400",
        null,
        this.translate?.report.validationFE.maximumEmailsExceeded,
        "warn",
        2000,
      );
      return;
    } else {
      //remove validators for users and group
      this.exportForm.controls["recipientsUser"].clearValidators();
      this.exportForm.controls["recipientsUser"].updateValueAndValidity();
      this.exportForm.controls["recipientsGroup"].clearValidators();
      this.exportForm.controls["recipientsGroup"].updateValueAndValidity();
    }
  }

  onEmailRemove(event: any){
    let emailList: any = this.exportForm.get("otherRecipients")?.value;
    if (emailList.length == 0) {
      this.exportForm.controls["recipientsUser"].setValidators([
        Validators.required,
      ]);
      this.exportForm.controls["recipientsGroup"].setValidators([
        Validators.required,
      ]);
      this.exportForm.controls["recipientsUser"].updateValueAndValidity();
      this.exportForm.controls["recipientsGroup"].updateValueAndValidity();
    }
  }

  onSwitchChange(event: any) {
    if (this.exportForm.get("sendEmail")?.value === true) {
      this.exportForm.controls["recipientsUser"].setValidators([
        Validators.required,
      ]);
      this.exportForm.controls["recipientsGroup"].setValidators([
        Validators.required,
      ]);
      this.exportForm.controls["otherRecipients"].setValidators([
        Validators.required,Validators.email
      ]);

      this.exportForm.controls["recipientsUser"].updateValueAndValidity();
      this.exportForm.controls["recipientsGroup"].updateValueAndValidity();
      this.exportForm.controls["otherRecipients"].updateValueAndValidity();
     // this.exportForm.updateValueAndValidity();

      if (this.users.length == 0) {
        this.getUsersList();
      }
      if (this.user_groups.length == 0) {
        this.getGroupList();
      }
    }
  }
}
